import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { RatingExtremesCard } from './rating-extremes-card';

export interface RatingSummaryProps {
  title: string;
  avgRating: number;
  count: number;
}

export const RatingExtremesOverview = ({
  topExtreme,
  bottomExtreme,
}: {
  topExtreme: RatingSummaryProps[];
  bottomExtreme: RatingSummaryProps[];
}) => {
  return (
    <Box sx={{ mx: 'auto', width: '100%', maxWidth: 720 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          '@media (min-width:1400px)': {
            gridTemplateColumns: '1fr 1fr',
          },
          gap: 3,
        }}
      >
        <Box>
          <Typography
            sx={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: 12,
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 1.5,
              color: 'success.main',
              mb: 1.5,
            }}
          >
            ▲ Highest Rated
          </Typography>
          <Stack spacing={1.5}>
            {topExtreme.map((z, i) => (
              <RatingExtremesCard key={z.title} ratingSummary={z} variant="top" rank={i + 1} />
            ))}
          </Stack>
        </Box>

        <Box>
          <Typography
            sx={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: 12,
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 1.5,
              color: 'error.main',
              mb: 1.5,
            }}
          >
            ▼ Lowest Rated
          </Typography>
          <Stack spacing={1.5}>
            {bottomExtreme.map((z, i) => (
              <RatingExtremesCard key={z.title} ratingSummary={z} variant="bottom" rank={bottomExtreme.length - i} />
            ))}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};
